import { TGetLiferayDataResponse } from "services/types";

export const mockGetLiferayData: TGetLiferayDataResponse = {
  actions: {
    get: {
      method: "GET",
      href: "https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/sites/37966/structured-contents",
    },
  },
  facets: [],
  items: [
    {
      actions: {
        "get-rendered-content": {
          method: "GET",
          href: "https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/structured-contents/68809/rendered-content/{contentTemplateId}",
        },
        "get-rendered-content-by-display-page": {
          method: "GET",
          href: "https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/structured-contents/68809/rendered-content-by-display-page/{displayPageKey}",
        },
        get: {
          method: "GET",
          href: "https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/structured-contents/68809",
        },
      },
      availableLanguages: ["pt-BR"],
      contentFields: [
        {
          contentFieldValue: {
            data: "Confira os benefícios da sua categoria",
          },
          dataType: "string",
          inputControl: "text",
          label: "Title",
          name: "title",
          nestedContentFields: [],
          repeatable: false,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Transforme passagens aéreas em pontos",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Sua empresa ganha 3% do valor pago na passagem aérea em pontos para usar em toda plataforma VoeBiz.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "voebiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Maior validade dos pontos",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Validade de 24 meses para pontos acumulados em voos GOL a partir da data de acúmulo.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "voebiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Time.svg/3f307350-a7fb-9fe8-55e8-1230c2a884de?t=1707745945523",
                  description: "Maior validade dos pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69752,
                  sizeInBytes: 6248,
                  title: "Time.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Troque seus pontos por passagens",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Junte pontos VoeBiz ao voar com a GOL.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "voebiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Plane.svg/9226894e-cdd6-ded0-7bbe-2b74aff32b39?t=1707746079924",
                  description: "Voe pelo Brasil e pelo mundo",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69767,
                  sizeInBytes: 5652,
                  title: "Plane.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Acelere o acúmulo de pontos VoeBiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Ganhe 30% de bônus em pontos VoeBiz ao pagar os voos com GOL UATP.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "voebiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Miles.svg/422a4760-bfb4-8944-71c2-2a5a3644bd98?t=1707746131591",
                  description: "Acelere o acúmulo de pontos VoeBiz",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69776,
                  sizeInBytes: 5688,
                  title: "Miles.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "As pessoas da sua equipe também ganham",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "A sua equipe junta milhas na Smiles enquanto sua empresa junta pontos no VoeBiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "voebiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Personal+info.svg/01709d1a-bd03-a77d-475a-f7b367828868?t=1707746223351",
                  description: "Seus funcionários também ganham",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69800,
                  sizeInBytes: 1839,
                  title: "Personal info.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Transforme passagens aéreas em pontos",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Sua empresa ganha 5% do valor pago na passagem aérea em pontos para usar em toda plataforma da VoeBiz.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "essencial",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Maior validade dos pontos",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Validade de 24 meses para pontos acumulados em voos GOL a partir da data de acúmulo.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "essencial",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Time.svg/3f307350-a7fb-9fe8-55e8-1230c2a884de?t=1707745945523",
                  description: "Maior validade dos pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69752,
                  sizeInBytes: 6248,
                  title: "Time.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Troque seus pontos por passagens",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Junte pontos VoeBiz ao voar com a GOL.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "essencial",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Plane.svg/9226894e-cdd6-ded0-7bbe-2b74aff32b39?t=1707746079924",
                  description: "Voe pelo Brasil e pelo mundo",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69767,
                  sizeInBytes: 5652,
                  title: "Plane.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Acelere o acúmulo de pontos VoeBiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Ganhe 30% de bônus em pontos VoeBiz ao pagar os voos com GOL UATP.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "essencial",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Miles.svg/422a4760-bfb4-8944-71c2-2a5a3644bd98?t=1707746131591",
                  description: "Acelere o acúmulo de pontos VoeBiz",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69776,
                  sizeInBytes: 5688,
                  title: "Miles.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "As pessoas da sua equipe também ganham",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "A sua equipe junta milhas na Smiles enquanto sua empresa junta pontos no VoeBiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "essencial",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Personal+info.svg/01709d1a-bd03-a77d-475a-f7b367828868?t=1707746223351",
                  description: "As pessoas da sua equipe também ganham",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69800,
                  sizeInBytes: 1839,
                  title: "Personal info.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Transforme passagens aéreas em pontos",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Sua empresa ganha 8% do valor pago na passagem aérea em pontos para usar em toda plataforma da VoeBiz.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos ",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Maior validade dos pontos",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Validade de 24 meses para pontos acumulados em voos GOL a partir da data de acúmulo.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Time.svg/3f307350-a7fb-9fe8-55e8-1230c2a884de?t=1707745945523",
                  description: "Maior validade dos pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69752,
                  sizeInBytes: 6248,
                  title: "Time.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Troque seus pontos por passagens",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Junte pontos VoeBiz ao voar com a GOL.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Plane.svg/9226894e-cdd6-ded0-7bbe-2b74aff32b39?t=1707746079924",
                  description: "Voe pelo Brasil e pelo mundo",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69767,
                  sizeInBytes: 5652,
                  title: "Plane.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Acelere o acúmulo de pontos VoeBiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Ganhe 30% de bônus em pontos VoeBiz ao pagar os voos com GOL UATP.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Miles.svg/422a4760-bfb4-8944-71c2-2a5a3644bd98?t=1707746131591",
                  description: "Acelere o acúmulo de pontos VoeBiz",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69776,
                  sizeInBytes: 5688,
                  title: "Miles.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "As pessoas da sua equipe também ganham",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "A sua equipe junta milhas na Smiles enquanto sua empresa junta pontos no VoeBiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Personal+info.svg/01709d1a-bd03-a77d-475a-f7b367828868?t=1707746223351",
                  description: "As pessoas da sua equipe também ganham",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69800,
                  sizeInBytes: 1839,
                  title: "Personal info.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Transforme passagens aéreas em pontos",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Sua empresa ganha 10% do valor pago na passagem aérea em pontos para usar em toda plataforma da VoeBiz.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "super prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos ",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Maior validade dos pontos",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Validade de 24 meses para pontos acumulados em voos GOL a partir da data de acúmulo.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "super prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Time.svg/3f307350-a7fb-9fe8-55e8-1230c2a884de?t=1707745945523",
                  description: "Maior validade dos pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69752,
                  sizeInBytes: 6248,
                  title: "Time.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Troque seus pontos por passagens",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Junte pontos VoeBiz ao voar com a GOL.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "super prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Plane.svg/9226894e-cdd6-ded0-7bbe-2b74aff32b39?t=1707746079924",
                  description: "Voe pelo Brasil e pelo mundo",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69767,
                  sizeInBytes: 5652,
                  title: "Plane.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Acelere o acúmulo de pontos VoeBiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Ganhe 30% de bônus em pontos VoeBiz ao pagar os voos com GOL UATP.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "super prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Miles.svg/422a4760-bfb4-8944-71c2-2a5a3644bd98?t=1707746131591",
                  description: "Acelere o acúmulo de pontos VoeBiz",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69776,
                  sizeInBytes: 5688,
                  title: "Miles.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "As pessoas da sua equipe também ganham",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "A sua equipe junta milhas na Smiles enquanto sua empresa junta pontos no VoeBiz",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "super prime",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Personal+info.svg/01709d1a-bd03-a77d-475a-f7b367828868?t=1707746223351",
                  description: "As pessoas da sua equipe também ganham",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69800,
                  sizeInBytes: 1839,
                  title: "Personal info.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "O melhor plano para cada pessoa",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Sua empresa escolhe os planos que vai disponibilizar para cada pessoa de acordo com seus próprios critérios. Também é possível disponibilizar o benefício em massa.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "club",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Personal+info-club.svg/bc0a0f78-f8a3-a20e-b3df-a6e68cdb0471?t=1707766517079",
                  description: "O melhor plano para cada pessoa",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69852,
                  sizeInBytes: 1840,
                  title: "Personal info-club.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Flexibilidade no nível de coparticipação",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Sua empresa escolhe o valor da coparticipação e paga apenas de acordo com o uso da equipe.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "club",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Task.svg/867dcb8b-14a3-4681-14ca-26cae9179994?t=1707766607477",
                  description: "Flexibilidade no nível de coparticipação",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69861,
                  sizeInBytes: 2965,
                  title: "Task.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Portal exclusivo para gestão do benefício",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Tudo em um só lugar! A pessoa responsável pela gestão do benefício pode cadastrar e excluir novas pessoas em uma página exclusiva dentro do portal Voebiz, além de adicionar ou retirar os planos de maneira simples e fácil.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "club",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Laptop.svg/9f447ec7-8290-c135-0980-786d113f7d47?t=1707766652567",
                  description: "Portal exclusivo para gestão do benefício",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69870,
                  sizeInBytes: 2681,
                  title: "Laptop.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Zero taxas adicionais",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Não tem cobrança de nenhum outro valor ou taxa administrativa. Sua empresa paga apenas a coparticipação de acordo com o uso dos planos contratados pela equipe.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "club",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon-club.svg/1b15c8d6-63cf-3170-cee7-7e2ae5863110?t=1707766707612",
                  description: "Zero taxas adicionais",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69879,
                  sizeInBytes: 2147,
                  title: "Coupon-club.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Pague mais barato nas tarifas",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Voe pelo Brasil e pelo mundo ao comprar passagens com condições especiais.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "exclusive",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Passagens em grupo",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Sua empresa possui condições especiais para emissão de passagens em grupo.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "exclusive",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Transporte seguro de cargas",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Use a GOLLOG com condições especiais para o transporte de cargas e encomendas.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "exclusive",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Voo privativo",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Fretamento de aeronaves de acordo com a necessidade da sua equipe.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "exclusive",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Milhas para sua equipe",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "A cada viagem corporativa, as pessoas da sua equipe podem juntar milhas na Smiles.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "exclusive",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Atendimento comercial exclusivo",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Nome do responsável - (00) 0-0000-0000 nome@email.com",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "exclusive",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
        {
          contentFieldValue: {},
          dataType: "",
          label: "Cards",
          name: "cards",
          nestedContentFields: [
            {
              contentFieldValue: {
                data: "Clube Smiles para Empresas",
              },
              dataType: "string",
              inputControl: "text",
              label: "Label",
              name: "label",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "Aproveite a condição especial negociada para impulsionar o bem-estar e lazer da sua equipe através de viagens.",
              },
              dataType: "string",
              inputControl: "text",
              label: "Description",
              name: "description",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "",
              },
              dataType: "string",
              inputControl: "text",
              label: "Link",
              name: "link",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                data: "exclusive-club",
              },
              dataType: "string",
              inputControl: "text",
              label: "Type",
              name: "type",
              nestedContentFields: [],
              repeatable: false,
            },
            {
              contentFieldValue: {
                image: {
                  contentType: "Document",
                  contentUrl:
                    "https://voebiz.dev1.smiles.com.br/documents/37966/69727/Coupon.svg/3b5599e0-6fbd-16be-44f2-7b68e17029da?t=1707745764527",
                  description: "Transforme passagens aéreas em pontos",
                  encodingFormat: "image/svg+xml",
                  fileExtension: "svg",
                  id: 69730,
                  sizeInBytes: 2165,
                  title: "Coupon.svg",
                },
              },
              dataType: "image",
              label: "Icon",
              name: "icon",
              nestedContentFields: [],
              repeatable: false,
            },
          ],
          repeatable: true,
        },
      ],
      contentStructureId: 44284,
      creator: {
        additionalName: "",
        contentType: "UserAccount",
        familyName: "Mello",
        givenName: "Jonas",
        id: 68716,
        name: "Jonas Mello",
      },
      customFields: [],
      dateCreated: "2024-04-01T12:18:06Z",
      dateModified: "2024-04-03T12:36:29Z",
      datePublished: "2024-04-01T12:17:00Z",
      description: "",
      externalReferenceCode: "68807",
      friendlyUrlPath: "vbz_category_benefits",
      id: 68809,
      key: "68807",
      keywords: [],
      numberOfComments: 0,
      priority: 0.0,
      relatedContents: [],
      renderedContents: [
        {
          contentTemplateId: "45114",
          contentTemplateName: "mmc_benefits-of-your-category",
          markedAsDefault: true,
          renderedContentURL:
            "https://voebiz.dev2.smiles.com.br/o/headless-delivery/v1.0/structured-contents/68809/rendered-content/45114",
        },
      ],
      siteId: 37966,
      subscribed: false,
      taxonomyCategoryBriefs: [],
      title: "vbz_category_benefits",
      uuid: "345c229f-541d-db27-8107-6a181e9e84c5",
    },
  ],
  lastPage: 1,
  page: 1,
  pageSize: 20,
  totalCount: 1,
};
